/**
 * Region Field Component
 * Dropdown for region filter (depends on market selection)
 */

import React from 'react'
import { FormControl, Select, MenuItem, Typography, Box, SelectChangeEvent } from '@mui/material'
import { RegionOption } from '../types'

interface RegionFieldProps {
  value: string
  onChange: (value: string) => void
  regionOptions: RegionOption[]
  disabled?: boolean
  loading?: boolean
  label?: string
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const RegionField: React.FC<RegionFieldProps> = ({
  value,
  onChange,
  regionOptions,
  disabled = false,
  loading = false,
  label = 'Region',
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value)
  }

  return (
    <Box>
      <Typography component="label" sx={labelStyle}>
        {label}
      </Typography>
      <FormControl fullWidth size="small" disabled={disabled || loading}>
        <Select displayEmpty value={value} onChange={handleChange}>
          <MenuItem value="">All Regions</MenuItem>
          {regionOptions.map((option) => (
            <MenuItem key={option.region_code} value={option.region_code}>
              {option.region_name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default RegionField
